import { render, staticRenderFns } from "./DropDownArrowIcon.vue?vue&type=template&id=14252d52&scoped=true"
var script = {}
import style0 from "./DropDownArrowIcon.vue?vue&type=style&index=0&id=14252d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14252d52",
  null
  
)

export default component.exports